import { Injectable } from '@angular/core';
import { resolve } from 'path';

@Injectable({
  providedIn: 'root'
})
export class UserSiginService {

  constructor() { }

  isCheckUserAuthntication(): Promise<boolean> {
    return new Promise((resolve) => {
      const userData = JSON.parse(localStorage.getItem('user'));
      console.log();
      if (userData) {
        resolve(true);
      } else {
        resolve(false)
      }
    })
  }
}
